export default __webpack_public_path__ + "23ad04efb87a9ddc779352ab91d99afc.png";